import { create } from "zustand"
import { persist } from "zustand/middleware"
import { ConsultationFormSchema } from "../schema/schema"

interface ConsultationFormState {
  data: Partial<ConsultationFormSchema>
  step: number
  updateFields: (fields: Partial<ConsultationFormSchema>) => void
  clearFields: () => void
  nextStep: () => void
  previousStep: () => void
  setStep: (step: number) => void
}

export const useConsultationFormStore = create<ConsultationFormState>()(
  persist(
    (set) => ({
      data: {
        medication: { name: "", cost: 0 },
        consultationType: undefined,
      },
      step: 1,
      updateFields: (fields) =>
        set((state) => ({
          data: { ...state.data, ...fields },
        })),
      clearFields: () =>
        set({
          data: {
            medication: { name: "", cost: 0 },
            consultationType: undefined,
          },
        }),
      nextStep: () =>
        set((state) => ({
          step: Math.min(state.step + 1, 2),
        })),
      previousStep: () =>
        set((state) => ({
          step: Math.max(state.step - 1, 1),
        })),
      setStep: (step) =>
        set({
          step,
        }),
    }),
    {
      name: "consultation-form-storage",
    },
  ),
)
